import * as actionTypes from "./actionTypes";

const initialState = {
  payoutList: [],
  paytmAssuredClaimReport: {
    csvData: "",
    isSearched: false,
  },
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.PAYOUT_LIST:
      return { ...state, payoutList: payload };
    case actionTypes.CLEAR_PAYOUT_DATA:
      return initialState;
    case actionTypes.CALCULATE_CUMULATIVE_DATA:
      return { ...state, cumulativeData: payload };
    case actionTypes.PAYTM_ASSURED_CLAIM_REPORT:
      return {
        ...state,
        paytmAssuredClaimReport: { csvData: payload, isSearched: true },
      };
    case actionTypes.CLEAR_PAYTM_ASSURED_CLAIM_REPORT:
      return {
        ...state,
        paytmAssuredClaimReport: { csvData: "", isSearched: false },
      };
    default:
      return state;
  }
};
